export enum NumberOfEmployees {
  Range1 = '1-15',
  Range2 = '16-50',
  Range3 = '51-200',
  Range4 = '201-500',
  Range5 = '501-1000',
  Range6 = '1001-5000',
  Range7 = '5001-10000',
  Range8 = '10001+',
}
